import { Map } from 'immutable';

import ReviewFormConstants from 'Shared/constants/ReviewForms.constants';

export const getSlug = reviewForm => {
  if (!Map.isMap(reviewForm)) {
    return false;
  }
  return reviewForm.get(ReviewFormConstants.Model.SLUG);
};

export const getFormType = reviewForm => {
  if (!Map.isMap(reviewForm)) {
    return false;
  }
  return reviewForm.get(ReviewFormConstants.Model.FORM_TYPE);
};

export const getAnswers = reviewForm => {
  if (!Map.isMap(reviewForm)) {
    return false;
  }
  return reviewForm.get(ReviewFormConstants.Model.ANSWERS);
};

export const getFormData = reviewForm => {
  if (!Map.isMap(reviewForm)) {
    return false;
  }
  return reviewForm.get(ReviewFormConstants.Model.FORM_DATA);
};

export const getStartedAt = reviewForm => {
  if (!Map.isMap(reviewForm)) {
    return false;
  }
  return reviewForm.get(ReviewFormConstants.Model.STARTED_AT);
};

export const getUserSlug = reviewForm => {
  if (!Map.isMap(reviewForm)) {
    return false;
  }
  return reviewForm.get(ReviewFormConstants.Model.USER_SLUG);
};

export const getReviewSlug = reviewForm => {
  if (!Map.isMap(reviewForm)) {
    return false;
  }
  return reviewForm.get(ReviewFormConstants.Model.REVIEW_SLUG);
};

export const getSubmittedAt = reviewForm => {
  if (!Map.isMap(reviewForm)) {
    return false;
  }
  return reviewForm.get(ReviewFormConstants.Model.SUBMITTED_AT);
};

export const getEditingSessionId = reviewForm => {
  if (!Map.isMap(reviewForm)) {
    return false;
  }
  return reviewForm.get(ReviewFormConstants.Model.EDITING_SESSION_ID);
};

export const getIntroduction = reviewForm => {
  if (!Map.isMap(reviewForm)) {
    return false;
  }
  return reviewForm.get(ReviewFormConstants.Model.INTRODUCTION);
};
